(function () {
    var objectUrls = new WeakMap();

    var SKIP_INPUT_MATCHERS = [
        '[hidden]',
        '.d-none',
        '.profile-form-head-input',
        '.temp-file-type',
        '.crop-fie-type',
    ];

    function translate(key, fallback) {
        if (typeof window.$trans === 'function') {
            var groups = ['main2', '__dashboard2', 'main', '__dashboard'];

            for (var i = 0; i < groups.length; i++) {
                var fullKey = groups[i] + '.' + key;
                var value = window.$trans(fullKey);

                if (value && value !== fullKey) {
                    return value;
                }
            }
        }

        return fallback;
    }

    function shouldSkipInput(input) {
        if (!input || input.type !== 'file') {
            return true;
        }

        if (input.closest('.file__uploader__box')
            || input.closest('.filepond--root')
            || input.dataset.armFileFieldSkip !== undefined) {
            return true;
        }

        for (var i = 0; i < SKIP_INPUT_MATCHERS.length; i++) {
            if (input.matches(SKIP_INPUT_MATCHERS[i])) {
                return true;
            }
        }

        return !!input.hidden;
    }

    function wrapperForInput(input) {
        return input ? input.closest('[data-arm-file-field]') : null;
    }

    function revokeObjectUrl(input) {
        var existingUrl = objectUrls.get(input);

        if (existingUrl) {
            URL.revokeObjectURL(existingUrl);
            objectUrls.delete(input);
        }
    }

    function fileNameText(input) {
        var files = input.files;

        if (!files || !files.length) {
            return translate('No file selected', 'No file selected');
        }

        if (files.length === 1) {
            return files[0].name;
        }

        return translate(':count files selected', ':count files selected')
            .replace(':count', String(files.length));
    }

    function showElement(element) {
        if (!element) {
            return;
        }

        element.classList.remove('d-none');
        element.hidden = false;
        element.style.display = '';
    }

    function hideElement(element) {
        if (!element) {
            return;
        }

        element.classList.add('d-none');
        element.hidden = true;
    }

    function syncPreview(input, wrapper) {
        var previewEnabled = wrapper.hasAttribute('data-arm-file-field-preview-enabled');

        if (!previewEnabled) {
            return;
        }

        var previewWrap = wrapper.querySelector('[data-arm-file-field-preview]');
        var previewImage = wrapper.querySelector('[data-arm-file-field-preview-image]');
        var previewFile = wrapper.querySelector('[data-arm-file-field-preview-file]');
        var previewFileName = wrapper.querySelector('[data-arm-file-field-preview-file-name]');
        var file = input.files && input.files[0];

        revokeObjectUrl(input);

        if (!file) {
            hideElement(previewWrap);

            if (previewImage) {
                previewImage.removeAttribute('src');
                hideElement(previewImage);
            }

            if (previewFile) {
                hideElement(previewFile);
            }

            return;
        }

        showElement(previewWrap);

        if (file.type && file.type.indexOf('image/') === 0 && previewImage) {
            var objectUrl = URL.createObjectURL(file);
            objectUrls.set(input, objectUrl);
            previewImage.src = objectUrl;
            showElement(previewImage);
            hideElement(previewFile);

            return;
        }

        if (previewImage) {
            previewImage.removeAttribute('src');
            hideElement(previewImage);
        }

        if (previewFile) {
            if (previewFileName) {
                previewFileName.textContent = file.name;
            }

            showElement(previewFile);
        }
    }

    function syncField(input) {
        var wrapper = wrapperForInput(input);

        if (!wrapper) {
            return;
        }

        var nameEl = wrapper.querySelector('[data-arm-file-field-name]');
        var clearButton = wrapper.querySelector('[data-arm-file-field-clear]');
        var hasFile = !!(input.files && input.files.length);

        if (nameEl) {
            nameEl.textContent = fileNameText(input);
        }

        wrapper.classList.toggle('arm-file-field--has-file', hasFile);
        wrapper.classList.toggle('arm-file-field--invalid', input.classList.contains('is-invalid'));
        wrapper.classList.toggle('arm-file-field--disabled', input.disabled);

        if (clearButton) {
            if (hasFile) {
                showElement(clearButton);
            } else {
                hideElement(clearButton);
            }
        }

        syncPreview(input, wrapper);
    }

    function clearField(input) {
        if (!input) {
            return;
        }

        input.value = '';
        revokeObjectUrl(input);
        syncField(input);
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function enhanceBareInput(input) {
        if (shouldSkipInput(input) || wrapperForInput(input)) {
            return;
        }

        var parent = input.parentNode;
        var wrapper = document.createElement('div');

        wrapper.className = 'arm-file-field';
        wrapper.setAttribute('data-arm-file-field', '');

        var controls = document.createElement('div');
        controls.className = 'arm-file-field__controls';

        input.classList.add('arm-file-field__native');
        input.setAttribute('data-arm-file-field-native', '');

        if (!input.id) {
            input.id = 'arm-file-field-' + Math.random().toString(36).slice(2, 11);
        }

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'arm-file-field__button';
        button.setAttribute('data-arm-file-field-trigger', '');
        button.innerHTML = '<i class="bi bi-upload" aria-hidden="true"></i><span>'
            + translate('Choose file', 'Choose file')
            + '</span>';

        var nameEl = document.createElement('span');
        nameEl.className = 'arm-file-field__name';
        nameEl.setAttribute('data-arm-file-field-name', '');
        nameEl.textContent = translate('No file selected', 'No file selected');

        var clearButton = document.createElement('button');
        clearButton.type = 'button';
        clearButton.className = 'arm-file-field__clear d-none';
        clearButton.setAttribute('data-arm-file-field-clear', '');
        clearButton.hidden = true;
        clearButton.innerHTML = '<i class="bi bi-x-lg" aria-hidden="true"></i>';

        parent.insertBefore(wrapper, input);
        controls.appendChild(input);
        controls.appendChild(button);
        controls.appendChild(nameEl);
        controls.appendChild(clearButton);
        wrapper.appendChild(controls);

        syncField(input);
    }

    function init(root) {
        var scope = root || document;

        scope.querySelectorAll('input[type="file"]').forEach(function (input) {
            if (!shouldSkipInput(input)) {
                enhanceBareInput(input);
                syncField(input);
            }
        });

        scope.querySelectorAll('[data-arm-file-field-native]').forEach(syncField);
    }

    function bindGlobalHandlers() {
        if (document.body.dataset.armFileFieldBound) {
            return;
        }

        document.body.dataset.armFileFieldBound = '1';

        document.addEventListener('click', function (event) {
            var trigger = event.target.closest('[data-arm-file-field-trigger]');

            if (trigger) {
                var wrapper = trigger.closest('[data-arm-file-field]');
                var input = wrapper ? wrapper.querySelector('[data-arm-file-field-native]') : null;

                if (input) {
                    event.preventDefault();
                    input.click();
                }

                return;
            }

            var clearButton = event.target.closest('[data-arm-file-field-clear]');

            if (clearButton) {
                var clearWrapper = clearButton.closest('[data-arm-file-field]');
                var clearInput = clearWrapper ? clearWrapper.querySelector('[data-arm-file-field-native]') : null;

                if (clearInput) {
                    event.preventDefault();
                    clearField(clearInput);
                }
            }
        });

        document.addEventListener('change', function (event) {
            var input = event.target;

            if (!input.matches || !input.matches('[data-arm-file-field-native]')) {
                return;
            }

            syncField(input);
        });
    }

    function observeNewInputs() {
        if (!window.MutationObserver) {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node instanceof HTMLElement) {
                        init(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    function bindModalEnhancer() {
        if (typeof window.jQuery === 'undefined') {
            return;
        }

        window.jQuery(document).on('shown.bs.modal', function (event) {
            init(event.target);
        });
    }

    function boot() {
        bindGlobalHandlers();
        init();
        observeNewInputs();
        bindModalEnhancer();
    }

    window.initArmFileFields = init;
    window.clearArmFileField = clearField;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
